import { initializeApp } from 'firebase/app';
import { getAnalytics, Analytics } from 'firebase/analytics';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAoeGJrsmBv5KhOdyDgPSGYVL1qpUA2kxg",
  authDomain: "sellall-2c4b2.firebaseapp.com",
  projectId: "sellall-2c4b2",
  storageBucket: "sellall-2c4b2.firebasestorage.app",
  messagingSenderId: "725256705024",
  appId: "1:725256705024:web:e160a2383368386e3a74e5",
  measurementId: "G-BSYZFLG77P"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser environment)
let analytics: Analytics | null = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics };
export default app;




